<template>
  <PflegeBaseSectionTemplate
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :background-color="getPflegeColornameFromHex(props.blok.backgroundColor.value)"
    :anchor="anchor"
    :text-align="props.blok.textAlign"
  >
    <template v-if="props.blok.media?.length > 0" #media>
      <Media
        :blok="props.blok.media[0]"
        :aspect-ratio="{
          desktop: aspectRatios.xs,
          tablet: aspectRatios.s,
          mobile: aspectRatios.s
        }"
      />
    </template>

    <template v-if="props.blok.intro?.length > 0" #intro>
      <IntroComponent :blok="props.blok.intro[0]" />
    </template>

    <template v-if="props.blok.collapse?.length > 0" #content>
      <CollapseComponent :blok="props.blok.collapse[0]" />
    </template>

    <template v-if="props.blok.firstDivider?.length > 0" #secondDivider>
      <Divider :blok="props.blok.firstDivider[0]" />
    </template>

    <template v-if="props.blok.closing?.length > 0" #closing>
      <ClosingComponent :blok="props.blok.closing[0]" />
    </template>

    <template v-if="props.blok.secondDivider?.length > 0" #thirdDivider>
      <Divider :blok="props.blok.secondDivider[0]" />
    </template>
  </PflegeBaseSectionTemplate>
</template>

<script setup>
import aspectRatios from '../constants/aspectRatios'
import { WPElementMedia } from '@webcarelbj/shared-bloks'
import { findComponent } from '@webcarelbj/shared-components'

const Media = findComponent(WPElementMedia)

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})
const anchor = computed(() => {
  return props.blok.intro?.length > 0 && props.blok.intro[0].anchor !== null
    ? props.blok.intro[0].anchor
    : ''
})
const { getPflegeColornameFromHex } = usePflegeUtils()
</script>
